import { useCallback } from 'react';
import LoadingScreen from '../../pages/guest/LoadingScreen';
import { useAppDispatch, useAppSelector } from '../../store/hooks';
import { completeSplash } from '../../store/slices/onboardingSlice';

export default function SplashScreen() {
  const dispatch = useAppDispatch();
  const hasCompleted = useAppSelector((s) => s.onboarding.hasCompletedSplash);

  const handleLoadingComplete = useCallback(() => {
    // Complete splash immediately after loading screen
    dispatch(completeSplash());
  }, [dispatch]);

  if (hasCompleted) return null;

  return <LoadingScreen onComplete={handleLoadingComplete} />;
}


